module.exports = __webpack_public_path__ + "img/diente31.4eb343f7.png";